import getWallet from "./wallet";
import abi from "../abi/xGold.json";
import globalAbi from "../abi/global.json";
import ownerAbi from "../abi/owner.json";
import marketingAbi from "../abi/marketing.json";
import busoAbi from "../abi/buso.json";
import autolp from "../abi/autolp.json";
import buso126 from "../abi/buso126.json";
import farm from "../abi/farm.json";
import { ethers } from "ethers";

// Polygon Mainnet

// LOCAL
// const proxyContract = "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0";
// const globalRewardContract = "0x381645d74a75b3E1d4aBa35c0764199199c2D8F9";
// const ownerContract = "0x5392A33F7F677f59e833FEBF4016cDDD88fF9E67";

// BSCTestnet
const proxyContract = "0x5b58CC6b0075FE913C8d4700Ba150E930FDEc37a";
const ownerContract = "0xc22B3b26Ba52F7b370526bD7D090b52520b4C00a";
const marketingWallet = "0x1caa40409D9166E5552b0DCC0f9f0867a7307400";

// const buso126Address = "0x9bF7Fe75CC862258958E5F543b918BBa2748A72e";
const buso126Address = "0x5e812E3020C12e998C8C52d5BEe049457b736134";

// export const autoBuyContract = "0x3316560Db66ee953EbBa0cA15A02cc7aA78cf17D";
export const autoBuyContract = "0x71b9151Ee77b7A759C8a1cB0988D1c2B1740898D";
export const autoBuyContractCreationBlockNumber = 44708254;

export const getAutoBuyContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(autoBuyContract, autolp, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

export const getBuso126Contract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(buso126Address, buso126, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

export const contractCreationBlockNumber = 39543840;

const getContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(proxyContract, abi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

export const getOwnerContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(ownerContract, ownerAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

export const getMarketingContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(marketingWallet, marketingAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

// Mainnet
const BUSO = "0x7E26081D41fD9a18a32b66268C8cC5c621eb1cF2";
export const busoContractCreationBlockNumber = 42135845;

// Mumbai
// const BUSO = "0x7b89E846a430F0E4C220E0a7caf2D4dA0D6a777f";

export const getBusoContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(BUSO, busoAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

// Mumbai
const busoFarm = "0x6b7c19c6a00e63c3F4e2Ad0e10496d5FA32bD9B7";

export const getBusoFarm = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(busoFarm, farm, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}


export default getContract;